const FAQs=[
    {
        "id":"1",
        "Ques":"What is Netflix?",
        "Ans":"Netflix is a streaming service that offers a wide variety of award-winning TV shows, movies, anime, documentaries and more – on thousands of internet-connected devices."
    },
    {
        "id":"2",
        "Ques":"How much does Netflix cost?",
        "Ans":"Watch Netflix on your smartphone, tablet, Smart TV, laptop, or streaming device, all for one fixed monthly fee. Plans range from ₹ 149 to ₹ 649 a month. No extra costs, no contracts."
    },
    {
        "id":"3",
        "Ques":"Where can I watch?",
        "Ans":"Watch anywhere, anytime. Sign in with your Netflix account to watch instantly on the web at netflix.com from your personal computer or on any internet-connected device that offers the Netflix app, including smart TVs, smartphones, tablets, streaming media players and game consoles."
    },
    {
        "id":"4",
        "Ques":"How do I cancel?",
        "Ans":"Netflix is flexible. There are no annoying contracts and no commitments. You can easily cancel your account online in two clicks. There are no cancellation fees – start or stop your account anytime."
    },
    {
        "id":"5",
        "Ques":"What can I watch on Netflix?",
        "Ans":"Netflix has an extensive library of feature films, documentaries, TV shows, anime, award-winning Netflix originals, and more. Watch as much as you want, anytime you want."
    },
    {
        "id":"5",
        "Ques":"Is Netflix good for kids?",
        "Ans":"The Netflix Kids experience is included in your membership to give parents control while kids enjoy family-friendly TV shows and films in their own space.        "
    },
]

export default FAQs;